import { useEffect, useRef, useState, useCallback } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import IconButton from "@mui/joy/IconButton";

import RotateLeftRoundedIcon    from "@mui/icons-material/RotateLeftRounded";
import RotateRightRoundedIcon   from "@mui/icons-material/RotateRightRounded";
import ImageSearchRoundedIcon   from "@mui/icons-material/ImageSearchRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import CloseRoundedIcon         from "@mui/icons-material/CloseRounded";
import CheckRoundedIcon         from "@mui/icons-material/CheckRounded";
import { Modal, ModalDialog, ModalOverflow } from "@mui/joy";
import { BASE_LAYOUTS, framedLayoutsForSize } from "../../layouts.config";



export default function ModalTemplates({ open, onClose, page, setPageLayout, activePage, activeSide, bookSize }) {
  const availableFramed = framedLayoutsForSize(bookSize);
  const isCover = activePage === 0;
  const isEndpaper = activePage === 1;

  if (!open) return null;

  const side = activeSide || "left";
  const currentLayoutId = side === "left" ? page?.leftLayoutId : page?.rightLayoutId;

  return (
    <Modal open={open} onClose={onClose} sx={{ zIndex: 10010 }}>
      <ModalOverflow>
        <ModalDialog
          size="md"
          sx={{
            width: 420,
            maxHeight: "80vh",
            borderRadius: "16px",
            p: 3,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
            <Typography sx={{ fontWeight: 700, fontSize: 18 }}>
              {isCover
                ? "Шаблон обложки"
                : `Шаблон — ${side === "left" ? "левая" : "правая"} страница`}
            </Typography>
            <IconButton size="sm" variant="plain" onClick={onClose}>
              <CloseRoundedIcon />
            </IconButton>
          </Box>

          {isCover ? (
            <Typography level="body-sm" sx={{ color: "text.tertiary", textAlign: "center", py: 4 }}>
              Обложка — фиксированный шаблон, изменить нельзя.
            </Typography>
          ) : (
            (() => {
              const renderCard = (layout) => (
                <Box
                  key={layout.id}
                  onClick={() => {
                    setPageLayout(isEndpaper ? "right" : side, layout.id);
                    onClose();
                  }}
                  sx={{
                    p: "12px 10px 10px",
                    borderRadius: "12px",
                    border: currentLayoutId === layout.id
                      ? "2px solid var(--joy-palette-primary-400)"
                      : "2px solid var(--joy-palette-divider)",
                    bgcolor: currentLayoutId === layout.id
                      ? "color-mix(in srgb, var(--joy-palette-primary-500) 10%, transparent)"
                      : "background.level1",
                    cursor: "pointer",
                    display: "flex", flexDirection: "column", alignItems: "center", gap: 1,
                    transition: "all 0.15s",
                    "&:hover": {
                      borderColor: "color-mix(in srgb, var(--joy-palette-primary-400) 60%, transparent)",
                      bgcolor: "color-mix(in srgb, var(--joy-palette-primary-500) 8%, transparent)",
                    },
                  }}
                >
                  <Box sx={{ color: "primary.600", opacity: currentLayoutId === layout.id ? 1 : 0.5 }}>
                    {layout.icon}
                  </Box>
                  <Typography
                    level="body-xs"
                    sx={{
                      fontSize: "11px", textAlign: "center", lineHeight: 1.2,
                      color: currentLayoutId === layout.id ? "primary.700" : "text.secondary",
                      fontWeight: currentLayoutId === layout.id ? 700 : 400,
                    }}
                  >
                    {layout.label}
                  </Typography>
                </Box>
              );

              return (
                <>
                  <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 1.5 }}>
                    {BASE_LAYOUTS.map(renderCard)}
                  </Box>
                  <Typography level="body-xs" sx={{ color: "text.tertiary", mt: 2.5, mb: 1.5, textAlign: "center", fontWeight: 700 }}>
                    Шаблоны листов с белыми краями
                  </Typography>
                  <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 1.5 }}>
                    {availableFramed.map(renderCard)}
                  </Box>
                </>
              );
            })()
          )}
        </ModalDialog>
      </ModalOverflow>
    </Modal>
  );
}